/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The QuestionDto model module.
 * @module model/QuestionDto
 * @version v0
 */
class QuestionDto {
    /**
     * Constructs a new <code>QuestionDto</code>.
     * @alias module:model/QuestionDto
     * @param content {String} 
     * @param difficulty {Number} 
     */
    constructor(content, difficulty) { 
        
        QuestionDto.initialize(this, content, difficulty);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, content, difficulty) { 
        obj['content'] = content;
        obj['difficulty'] = difficulty;
    }

    /**
     * Constructs a <code>QuestionDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuestionDto} obj Optional instance to populate.
     * @return {module:model/QuestionDto} The populated <code>QuestionDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new QuestionDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('page_id')) {
                obj['page_id'] = ApiClient.convertToType(data['page_id'], 'Number');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('interpretation')) {
                obj['interpretation'] = ApiClient.convertToType(data['interpretation'], 'String');
            }
            if (data.hasOwnProperty('difficulty')) {
                obj['difficulty'] = ApiClient.convertToType(data['difficulty'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'String');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>QuestionDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>QuestionDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of QuestionDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['interpretation'] && !(typeof data['interpretation'] === 'string' || data['interpretation'] instanceof String)) {
            throw new Error("Expected the field `interpretation` to be a primitive type in the JSON string but got " + data['interpretation']);
        }
        // ensure the json data is a string
        if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
            throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
        }
        // ensure the json data is a string
        if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
            throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
        }

        return true;
    }


}

QuestionDto.RequiredProperties = ["content", "difficulty"];

/**
 * @member {Number} id
 */
QuestionDto.prototype['id'] = undefined;

/**
 * @member {Number} page_id
 */
QuestionDto.prototype['page_id'] = undefined;

/**
 * @member {String} content
 */
QuestionDto.prototype['content'] = undefined;

/**
 * @member {String} interpretation
 */
QuestionDto.prototype['interpretation'] = undefined;

/**
 * @member {Number} difficulty
 */
QuestionDto.prototype['difficulty'] = undefined;

/**
 * @member {Date} created_at
 */
QuestionDto.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
QuestionDto.prototype['updated_at'] = undefined;

/**
 * @member {String} created_by
 */
QuestionDto.prototype['created_by'] = undefined;

/**
 * @member {String} updated_by
 */
QuestionDto.prototype['updated_by'] = undefined;






export default QuestionDto;

